import apiClient from './client';
import { LoginConsentResponseMessage } from '@/types/LoginConsentResponse';

/**
 * Records user consent for terms of service, privacy policy, and age confirmation.
 * Sends a request to the server to record consent and returns the updated user profile.
 */
export async function writeLoginConsent(): Promise<LoginConsentResponseMessage> {
  // The server will record that the user has consented and return an updated profile
  const response = await apiClient.post<LoginConsentResponseMessage>(
    '/secure/login/consent');
  return response.data;
}
